var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 337,
    cy: 238,
    rx: 158,
    ry: 159,
    fill: "#f0fff1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276.977 161.156H397.965V175.761H352.313C352.313 175.761 366.828 190.952 366.828 200.885H397.832V214.321H368.146C368.146 214.321 362.208 259.657 305.343 256.853L374.744 330.819H347.037L276.977 259.426V244.469C276.977 244.469 311.413 245.402 327.905 235.471C341.23 227.409 339.515 222.501 340.702 217.826C341.1 216.074 339.646 214.439 337.667 214.439H276.977V201.001H339.121C340.438 201.001 341.23 199.832 340.572 198.78C337.931 194.224 330.94 184.057 321.309 182.189C308.773 179.853 276.977 179.267 276.977 179.267V161.156Z",
    fill: "#231942"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107 122H238",
    stroke: "#f0fff1",
    strokeWidth: 19.9406,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 309H201",
    stroke: "#f0fff1",
    strokeWidth: 19.9406,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54 180H188",
    stroke: "#f0fff1",
    strokeWidth: 19.9406,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112 362H246",
    stroke: "#f0fff1",
    strokeWidth: 19.9406,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83 243H187",
    stroke: "#f0fff1",
    strokeWidth: 19.9406,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 243H48",
    stroke: "#f0fff1",
    strokeWidth: 19.9406,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33 122H70",
    stroke: "#f0fff1",
    strokeWidth: 19.9406,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14 362H76",
    stroke: "#f0fff1",
    strokeWidth: 19.9406,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstant);
export default __webpack_public_path__ + "static/media/instant.3f7be021436b0188de27b2569139b947.svg";
export { ForwardRef as ReactComponent };